import styled from 'styled-components';

export const Container = styled.div`
  .ant-row.ant-form-item {
    margin-bottom: .5rem;
  }
`;
